/**
 * Sport icons for the onboarding sports step, copied from the onboarding
 * design frame and keyed by the catalog's sportKey.
 */

import type { ReactNode } from "react";

const FALLBACK_ICON_BODY: ReactNode = <circle cx="12" cy="12" r="9" />;

const SPORT_ICON_BODIES: Record<string, ReactNode> = {
  football: (
    <g transform="rotate(-45 12 12)">
      <ellipse cx="12" cy="12" rx="9" ry="5.5" />
      <path d="M8.5 12h7M10.5 10.5v3M13.5 10.5v3" />
    </g>
  ),
  basketball: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3v18M5.6 5.6c3 3 3 9.8 0 12.8M18.4 5.6c-3 3-3 9.8 0 12.8" />
    </>
  ),
  baseball: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M6 4.5c2.5 2 2.5 13 0 15M18 4.5c-2.5 2-2.5 13 0 15" />
    </>
  ),
  hockey: (
    <>
      <path d="M5 3l6.5 12.5A3 3 0 0 0 14.2 17H19" />
      <ellipse cx="16.5" cy="19.5" rx="3" ry="1.5" />
    </>
  ),
  golf: (
    <>
      <path d="M9 21V4l8 3-8 3" />
      <ellipse cx="12" cy="21" rx="6" ry="1.5" />
    </>
  ),
  soccer: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8l3.6 2.6-1.4 4.2h-4.4L8.4 10.6zM12 8V3.5M15.6 10.6l4.2-1.4M14.2 14.8l2.6 3.6M9.8 14.8l-2.6 3.6M8.4 10.6 4.2 9.2" />
    </>
  ),
  mma: <path d="M8 3h8l5 5v8l-5 5H8l-5-5V8z" />,
  // ISSUE-1299. A pool with no league: a pencil, for games you name yourself.
  custom: (
    <>
      <path d="M4 20l1-4L16 5l3 3L8 19z" />
      <path d="M14 7l3 3M4 20h16" />
    </>
  ),
};

export function SportIcon({ sportKey }: { sportKey: string }): ReactNode {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {SPORT_ICON_BODIES[sportKey] ?? FALLBACK_ICON_BODY}
    </svg>
  );
}
